import { render, staticRenderFns } from "./SeamAllowanceSelect.vue?vue&type=template&id=41766ff2"
import script from "./SeamAllowanceSelect.vue?vue&type=script&lang=js"
export * from "./SeamAllowanceSelect.vue?vue&type=script&lang=js"
import style0 from "./SeamAllowanceSelect.vue?vue&type=style&index=0&id=41766ff2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports